import React, { useEffect } from 'react';
import { LoadingSpinner } from '../../../components/loading-spinner/loading-spinner.component';

import { connect } from 'react-redux';
import { loggedIn, isLoginInProgress } from '../../../redux/auth/selectors';
import { getData, localStorageKey } from '../../../redux/utils';
import { relocateUser } from '../LoginScreen/utils';
import { internalRoutePaths } from '../../../config/config';

export const DefaultPathBase = (props) => {
  const savedData = getData(localStorageKey);
  useEffect(() => {
    if (props.loggedIn) {
      const url = props.history.location?.state?.from?.pathname
        ? props.history.location.state.from.pathname
        : savedData?.user?.client?.is_onboarded
        ? internalRoutePaths.WORKSPACES
        : internalRoutePaths.ONBOARDING;

      relocateUser(savedData?.user, props.history, url);
    } else {
      const appleSiteAssociationFileUrl =
        '/.well-known/apple-app-site-association';
      if (props.location.pathname !== appleSiteAssociationFileUrl) {
        props.history.push('/login');
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loginSent, props.loggedIn]);

  if (
    props.loggedIn ||
    props.translationLoading ||
    props.loginSent ||
    props.location.pathname === '/login'
  ) {
    return null;
  }

  return <LoadingSpinner />;
};

const mapStateToProps = (state) => ({
  loggedIn: loggedIn(state),
  loginSent: isLoginInProgress(state),
});

export default connect(mapStateToProps, {})(React.memo(DefaultPathBase));
